'use client';

import React from 'react';
import { Section } from '@/components/client/Section/Section';
import { Container } from '@/components/client/Container/Container';
import { MainSectionLayout } from '@/features/client/MainSectionLayout/MainSectionLayout';
import { MainSection } from '@/features/client/MainSection/MainSection';
import { ContactUsBanner } from '@/features/client/ContactUsBanner/ContactUsBanner';
import { Careers } from '@/features/client/Careers/Careers';

const CareersPage = () => {
  return (
    <div>
      {' '}
      <MainSectionLayout variant="primary" layout="sline">
        <MainSection
          label="Careers"
          title="Careers"
          description="Join the Tytum Team"
        />
      </MainSectionLayout>
      <Section styles={{ paddingTop: 20 }} variant="secondary">
        <Container>
          <Careers />
        </Container>
      </Section>
      <Section>
        <Container>
          <ContactUsBanner />
        </Container>
      </Section>
    </div>
  );
};
export default CareersPage;
